module.exports = __webpack_public_path__ + "static/media/documentation.46d416d3.md";